import Col from 'react-bootstrap/Col';

export default Col;
